<template>
    <div class="relative w-screen h-svh overflow-hidden flex">
        <slot />
    </div>
</template>
